module.exports = __webpack_public_path__ + "static/media/logotext-pos.ca86e19b.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/logotext-pos.png
// module id = 855
// module chunks = 0